.pes-document-listing {
  font-size: 0.8125rem;
  line-height: 1.5rem;
  font-weight: 300;
  margin: var(--document-listing-top-margin-mobile, 40px) auto auto;
}

@media screen and (min-width: 980px) {
  .pes-document-listing {
    margin-top: var(--document-listing-top-margin, 20px);
  }
}